import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type TCreateBudgetUploadFile = {
    projectId: string;
    params: any;
};

export default async ({ projectId, params }: TCreateBudgetUploadFile) => {
    const tempHeaders = {
        auth: true,
        "Content-Type": "multipart/form-data",
    };

    const httpRequest = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/project/${projectId}/attachment/upload`,
        method: "post",
        body: params,
        headers: tempHeaders,
    });
    const { body, statusCode } = httpRequest;

    return handleStatusCases({ body, statusCode });
};
